import React from 'react'
import { CookiesPolicy } from '@templates'

const Cookies = () => <CookiesPolicy />

export default Cookies
